import React from 'react';
import {Button, Form, FormGroup, Label, Input, FormText, Container, Row, Col, Badge} from 'reactstrap';
import axios from 'axios';
import "react-table/react-table.css";
import Calendar  from 'react-calendar';
import _ from 'lodash';
import withTracker from '../containers/Full/withTracker';
import {withRouter, Link } from "react-router-dom";
import {connect} from 'react-redux';

import RequestForm from './RequestForm';
import FirstMsgForm from "./FirstMsgForm";
import {editProfile} from "../modules/actions/user";
import {firstMessage} from "../modules/actions/message";
import {firstMessageList} from "../modules/actions/message";


import '../styles/sideProfile.scss';
import '../styles/sellerDetail.scss'
import '../styles/profile.scss';
import travellerIcon from '../img/traveller.jpg';

class Profile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            showForm: false,
            showMsgForm: false,
            editEnabled: false,
            isFirstMsg: false,
            // msgId: '',
        };

      //  this.showUserInfo = this.showUserInfo.bind(this);
        this.getDetail = this.getDetail.bind(this);
        this.getDate = this.getDate.bind(this);
        this.toggleForm = this.toggleForm.bind(this);
        this.toggleMsgForm = this.toggleMsgForm.bind(this);
        this.getAcceptList = this.getAcceptList.bind(this);
        this.showWidget = this.showWidget.bind(this);
        this.renderEditPage = this.renderEditPage.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.saveEditPage = this.saveEditPage.bind(this);
        this.getType = this.getType.bind(this);
        this.checkFirstMsg = this.checkFirstMsg.bind(this);

        this.widget = window.cloudinary.createUploadWidget({
            cloudName: "pearlcloudinary", uploadPreset: "profile_preset" }, (error, result) => {this.checkUploadResult(result) });

        // console.log("---->",this.widget);
    }

    componentDidMount() {
   //     this.showUserInfo();
        this.getType();
        // this.checkFirstMsg();
        // this.getDetail();
    }

    // showUserInfo(){
    //     let that = this;
    //     console.log("profile this state", this.state);
    //     axios.get('https://spice-api.pearlfall.now.sh'+`/users/getUser`, this.state)
    //         .then(function (response) {
    //             console.log('show user info in profile',response);
    //             that.setState({
    //                 username: response.data.username,
    //             });
    //             console.log("name", that.state.username);
    //         })
    //         .catch(function (error) {
    //             console.log(error);
    //         })
    // }

    getType(){
        let that = this;
        let payload={
            "username": this.props.match.params.username,
        }
        axios.post('https://spice-api.pearlfall.vercel.app'+`/users/getType`, payload)
            .then((response)=>{
                // console.log('response get type', response.data.type);
                that.setState({
                    profileType: response.data.type,
                }, ()=>{
                    that.getDetail();
                })
            }).catch((err)=>{
                console.log(err);
        })

    }

    async checkFirstMsg(){
        // let that = this;
        let payload = {
            //profile owner name
            "username": this.state.username
        }
        let result = await this.props.dispatch(firstMessageList(payload));
        // console.log("check first message", result);
        if (result.length>0){
            this.setState({isFirstMsg: !this.state.isFirstMsg});
            this.setState({msgId: result[0]._id });
        }
    }

    async getDetail(){
        let that = this; //this는 dashboardBuyer component!
        // console.log(this); // not undefined
        // console.log("this.props", this.props);
        let payload = {
            "username": this.props.match.params.username,
        }
        // console.log("profile types", this.state.profileType);
        await axios.post(this.state.profileType === 'Buyer' ?
            'https://spice-api.pearlfall.vercel.app'+`/users/profile/buyer` :
            'https://spice-api.pearlfall.vercel.app'+`/users/profile/seller`, payload)
            .then(function (response) {
                // console.log(this, that); //after function, it's undefined
                // console.log('response profile detail', response);
                that.setState({ //this.setState 하면 undefined나오는데, 이유는 then안에서 불리는 this는 dashboardBuyer component를 가리키지 않음
                    //따라서 that에 this를 저장해서 여기서 불러야함
                    sellerId: response.data.user.sellerId,
                    username: response.data.user.username,
                    name: response.data.user.name,
                    region: response.data.user.region,
                    topic: response.data.user.topic,
                    description: response.data.user.description,
                    avgScore: response.data.user.avgScore,
                    totalDeals: response.data.user.totalDeals,
                    keywords: response.data.user.keywords,
                    comments: response.data.user.comments,
                    photoUrl: response.data.user.photoUrl,
                    aboutMe: response.data.user.aboutMe,
                }, ()=>{
                    // call after sellerId set on state
                    // console.log("check comments", that.state.comments);
                    // console.log("is seller id set?", that.state.sellerId);
                    // setTimeout(()=> { that.getAcceptList();}, 1000);
                    that.getAcceptList();
                    // console.log("do you comeback here?");
                    that.checkFirstMsg();
                });
                // console.log("description", that.state.description);
            })
            .catch(function (error) {
                console.log(error);
            })
    }

    async getAcceptList(){
        let that = this;
        let payload = {
            "userId": this.state.sellerId,
        }
        await axios.post('https://spice-api.pearlfall.vercel.app'+`/requests/acceptedList/seller`, payload)
            .then(function (response) {
                // console.log('response seller id accepted list', response);
                // console.log("All dates", _.map(response.data.request, 'date'));
                //there is one state ("occupiedDate") How can I set multiple occupied dates
                //into one state?
                that.setState({
                    // sellerId: response.data.request.sellerId,
                    occupiedDate: _.map(response.data.request, 'date')
                    //So Seller8 has 3 occupiedDates, but I don't know how to show all of them
                    //for now, I only made show one occupiedDate
                });
            })
            .catch(function (error) {
                console.log(error);
            });
        // console.log("you come here");
        const disabledDates = [new Date(that.state.occupiedDate)];
        // console.log("when is disable",disabledDates, that.state.occupiedDate);

    }

    getDate(date){
        this.setState({date});
        // var selectedDate = date.toLocaleString().split(',').splice(0,1);
        let selectedDate = new Date(date).toString();
        this.setState({
            selectedDate: selectedDate
        })
        // console.log("what date", selectedDate);
    }

    toggleForm(){
        this.setState({
            showForm: !this.state.showForm
        })
    }

    toggleMsgForm(){
        this.setState({
            showMsgForm: !this.state.showMsgForm
        })
    }

    handleChange(event){
        let values = this.state;
        // console.log('values ', values);
        // console.log(event.target.name);
        values[event.target.name] = event.target.value;
        this.setState(values);
        // console.log('profile handle change:',values, this.state);
        // console.log('profile handle change:', this.state.aboutMe);
    }

    renderEditPage(){
        this.setState({editEnabled: !this.state.editEnabled});
    }

    saveEditPage(){
        let that = this;
        let payload = {
            photoUrl: this.state.photoUrl,
            aboutMe: this.state.aboutMe
        }
        this.props.dispatch(editProfile(payload))
            .then(()=>{
                that.setState({editEnabled: false})
            })
    }

    checkUploadResult(resultEvent){
        if(resultEvent.event === 'success'){
            // console.log(resultEvent.info.url);
            this.setState({photoUrl: resultEvent.info.url});
            // console.log(this.props.currentUser.id);
            // this.props.postPhoto({user_id: this.props.currentUser.id,
            // caption:'',
            // url: resultEvent.info.secure_url})
            //     .then(this.props.history.push(`/profile`))
        }
    }

    showWidget() {
        this.widget.open();
    }

    render() {
        // if (this.state.occupiedDate){
        //     console.log("occupied date???", new Date(this.state.occupiedDate));
        //     let disabledDates = [new Date(this.state.occupiedDate)];
        // }

        // widget.open();

        // console.log("comment", this.state.comments);
        // console.log("what is type", this.state.ownerType);

        // console.log("user", this.props.user);
        const testDates = [
            new Date(2019, 10, 29),
            // because you set the month 10. Date's month field start from 0
            // So nov is 11 - 1 = 10

        ];
        const disabledDates = this.state.occupiedDate ?
            this.state.occupiedDate.map((item)=> new Date(item)) : [];
        // this one the trick, if no state.occupiedDate we just use empty array
        //Ahh so it makes calendar waits until disabledDates set on the state? >> Yes
        // console.log("disable dates", disabledDates);
        // console.log("test dates", testDates);
        // console.log("occupied date:", this.state.occupiedDate, this.state.occupiedDate !== undefined);

        return (
            // (this.state.occupiedDate) &&
            <div className="profile-right">

                <h1 className="text-center description">
                    {this.state.description}
                </h1>
                <div className="seller-detail">
                    {/*<Row>*/}
                        <div>
                        {/*<Col xs="3">*/}
                            <div className="profile-intro">
                                <img src={this.state.photoUrl ? this.state.photoUrl : travellerIcon} className="seller-img"/>
                                <div className="description-mobile">
                                    " {this.state.description} "
                                </div>
                            </div>
                            {
                                !this.state.editEnabled ?
                                    <div></div>
                                :
                                <div>
                                    {/*https://cloudinary.com/documentation/upload_widget*/}
                                    {/*https://medium.com/@jordanmmartin/quickstart-guide-to-using-cloudinary-upload-widget-v2-in-react-4c4d9041d55e*/}
                                    <button onClick={this.showWidget} style={{"background-color":"darkseagreen", "margin":"auto", "display":"flex"}}>Upload photo</button>
                                </div>
                            }

                            {/*<div style={{"margin-left": "20px"}}>*/}
                            {/*    <strong>Name</strong>: {this.state.name} <br />*/}
                            {/*    <strong>Username</strong>: {this.state.username} <br />*/}
                            {/*    <strong>Region</strong>: {this.state.region} <br />*/}
                            {/*    <strong>Talent</strong>: {this.state.topic} <br />*/}
                            {/*    <strong>Description</strong>: {this.state.description} <br />*/}
                            {/*    <br />*/}
                            {/*    <strong>Total deals</strong>: {this.state.totalDeals} <br />*/}
                            {/*    <strong>Average score</strong>: {Math.round(this.state.avgScore * 10)/10} <br />*/}
                            {/*</div>*/}
                            <div>
                                {(this.state.username !== this.props.user.username) ?
                                    (!this.state.isFirstMsg ? <button className="btn-chat" onClick={this.toggleMsgForm}>Start Conversation!</button>
                                        :  <Link className="btn-chat"
                                                 to={"/dashboard/message/"+this.state.msgId}>View Conversation</Link>)
                                    :<div></div>
                                }
                                {this.state.showMsgForm ?
                                    <FirstMsgForm closeForm={this.toggleMsgForm}
                                                  recipientName = {this.state.username}
                                    /> : null}
                            </div>
                        {/*</Col>*/}
                        </div>

                        {
                            !this.state.editEnabled ?
                                <div>
                                {/*<Col xs="3">*/}
                                    <div>
                                        {/*<strong>Name</strong>: {this.state.name} <br />*/}
                                        <strong>Username</strong>: {this.state.username} <br />
                                        <strong>Region</strong>: {this.state.region} <br />
                                        <strong>Talent</strong>: {this.state.topic} <br />
                                        {/*<strong>Description</strong>: {this.state.description} <br />*/}
                                        <hr></hr>
                                        <strong>Total deals</strong>: {this.state.totalDeals ? this.state.totalDeals : 0} <br />
                                        <strong>Average score</strong>: {this.state.avgScore ?
                                        Math.round(this.state.avgScore * 10)/10 : "No score yet"} <br />
                                        <hr></hr>
                                    </div>
                                    <div className="about-me"> About Me </div>
                                    {this.state.aboutMe}
                                {/*</Col>   */}
                                </div>
                                :
                                <div>
                                {/*<Col xs="3">*/}
                                    <div>
                                        <strong>Name</strong>: {this.state.name} <br />
                                        <strong>Username</strong>: {this.state.username} <br />
                                        <strong>Region</strong>: {this.state.region} <br />
                                        <strong>Talent</strong>: {this.state.topic} <br />
                                        <strong>Description</strong>: {this.state.description} <br />
                                        <hr></hr>
                                        <strong>Total deals</strong>: {this.state.totalDeals ? this.state.totalDeals : 0} <br />
                                        <strong>Average score</strong>: {this.state.avgScore ?
                                        Math.round(this.state.avgScore * 10)/10 : "No Score"} <br />
                                        <hr></hr>
                                    </div>
                                    <strong>About Me:</strong>
                                    <br />
                                    <textarea
                                        value={this.state.aboutMe}
                                        name="aboutMe" id="aboutMe"
                                        placeholder="Explain your experience and share your own story!"
                                        style={{ width: '100%', height: '25vh' }}
                                        onChange={this.handleChange.bind(this)}
                                />
                                {/*</Col>*/}
                                </div>
                        }

                        <div className="calendar">
                        {/*<Col xs="4">*/}
                            {/*{this.state.occupiedDate &&*/}
                            {this.state.profileType === 'Seller' &&
                                < Calendar className="calendar" onChange={this.getDate} minDate={new Date()} value={this.state.date}
                                    tileDisabled={({date, view}) =>
                                    (view === 'month') &&// Block day tiles only
                                    disabledDates.some(disabledDate =>
                                    date.getFullYear() === disabledDate.getFullYear() &&
                                    // This one, compare date month field to another date month field
                                    // So no need to deduct one of them by 1
                                    date.getMonth() === (disabledDate.getMonth()) &&
                                    date.getDate() === disabledDate.getDate()
                                    )}
                                    />
                            }

                            {/*}*/}
                        {/*</Col>*/}
                        </div>
                        <div className="profile-button">
                        {/*<Col xs="2">*/}
                            {/*{this.state.username}{' '}{this.props.user.username}*/}
                            {/*nested condition operator*/}
                            { (this.state.username === this.props.user.username) ?
                                (!this.state.editEnabled  ?
                                        <button className="btn-request" onClick={this.renderEditPage}>Edit</button>
                                      : <button className="btn-request" onClick={this.saveEditPage}>Save</button>)
                                : <div>
                                    {/*<Link className="btn-chat" to="/dashboard/message">Start Conversation</Link>*/}
                                    {this.state.profileType === "Seller" ?
                                    <button className="btn-request" onClick={this.toggleForm}>Request 1-on-1 hangout</button>
                                        : ''}
                                    {this.state.showForm ?
                                        <RequestForm closeForm={this.toggleForm}
                                                     sellerName = {this.state.username} selectedDate = {this.state.selectedDate}
                                                     topic = {this.state.topic} sellerId = {this.state.sellerId}
                                        /> : null}
                                </div>
                            }
                        {/*</Col>*/}
                        </div>
                    {/*</Row>*/}
                </div>
                <div style={{"padding":"30px"}}>
                    <div style = {{"font-size": "20px", "font-weight":"bold"}}>Keyword: <br /> </div>
                    {this.state.keywords && this.state.keywords.map((keyword)=>{
                        {/* return <div>{keyword.keyword} ({keyword.count})</div>*/}
                        return (
                            <Badge
                                name={keyword} color= "info" pill
                                className="badge"
                                onClick={()=>this.onClick(keyword)}
                            ><span className="keyword-text">{keyword.keyword} </span> <span className="keyword-count">({keyword.count})</span> </Badge>
                        );
                    })}
                </div>
                <br />
                <div style = {{"font-size": "20px", "font-weight":"bold", "padding":"30px"}}> Review from other users...</div>
                {this.state.comments && this.state.comments.map((comment)=>{
                    // console.log("comments profile", this.state.comments);
                    let reviewUnix = comment.timeStamp;
                    let reviewDate = new Date(reviewUnix*1000);
                    // console.log("review date", reviewUnix, reviewDate.toLocaleString());
                    return (
                        <div className="review-container">
                            <div className="review-img">
                                <img src={comment.senderPhoto ? comment.senderPhoto : travellerIcon}
                                     // style={{"width":"50px", "height":"50px", "margin-left":"30px", "margin-top":"10px"}}
                                    className="profile-img"
                                />
                            </div>
                            <div className="review">
                                <div>
                                    <div style={{"font-weight":"bold"}}>
                                        <a href={"/dashboard/profile/"+comment.senderName}>{comment.senderName}</a>
                                        <span style={{"font-size":"10px"}}>{reviewDate.toLocaleString()}</span></div>
                                    <div>{comment.comment}</div>
                                    <br />
                                    <hr></hr>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

function mapStateToProps(store) {
    return {
        user: store.auth.user,
    };
}


export default withTracker(withRouter(connect(mapStateToProps)(Profile)));
